export default "/_next/static/images/3acd04d0dc47c0bbd40a80968b5d9c05.png";